import React from "react";
import Container from "@/components/marketing/Container";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useAuth } from "@/lib/AuthContext";
import Reveal from "@/components/marketing/Reveal";

export default function PackagesCTA() {
  const { isAuthenticated } = useAuth();
  const primaryTo = isAuthenticated ? "/dashboard/new-order" : "/register";

  return (
    <section className="relative bg-cobalt overflow-hidden">
      <Container className="relative py-10 sm:py-12 lg:py-14 text-center">
        <Reveal>
        <span className="font-mono text-xs uppercase tracking-widest text-white/80 inline-block mb-6">
          GET STARTED
        </span>
        <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight mb-5">
          Skip the guesswork.
        </h2>
        <p className="text-white/85 text-base lg:text-lg max-w-2xl mx-auto mb-10 leading-relaxed">
          Pick your package and our team handles the mix.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to={primaryTo}
            className="inline-flex items-center bg-white hover:bg-white/90 text-cobalt font-medium px-8 py-3 rounded-lg text-[15px] transition-colors"
          >
            Get Started <ArrowRight className="ml-2 w-4 h-4" />
          </Link>
          <Link
            to="/contact"
            className="inline-flex items-center border border-white text-white bg-transparent hover:bg-white/10 hover:text-white px-8 py-3 rounded-lg text-[15px] transition-colors"
          >
            Talk to Our Team
          </Link>
        </div>
        </Reveal>
      </Container>
    </section>
  );
}